import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
    NbButton,
    NbButtonModule,
    NbCardModule,
    NbLayoutModule,
    NbMenuModule,
    NbSidebarModule,
} from "@nebular/theme";
import { ThemeModule } from "../@theme/theme.module";
import { TokenReleaseComponent } from "./token-release.component";
import { TokenReleaseRoutingModule } from "./token-release-routing.module";
import { TokenReleaseLayoutComponent } from "./token-release.layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
    declarations: [TokenReleaseComponent, TokenReleaseLayoutComponent],
    imports: [
        CommonModule,
        NbSidebarModule,
        NbMenuModule,
        NbLayoutModule,
        ThemeModule,
        NbCardModule,
        NbButtonModule,
        FormsModule,
        ReactiveFormsModule,
        TokenReleaseRoutingModule,
    ],
})
export class TokenReleaseModule {}
